var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
/* eslint-disable @typescript-eslint/no-explicit-any */
import { Property, ChildProperty } from '@syncfusion/ej2-base';
/**
 * Configuration that applies on each appointment field options of scheduler.
 */
export class FieldOptions extends ChildProperty {
}
__decorate([
    Property()
], FieldOptions.prototype, "name", void 0);
__decorate([
    Property()
], FieldOptions.prototype, "default", void 0);
__decorate([
    Property()
], FieldOptions.prototype, "title", void 0);
__decorate([
    Property({})
], FieldOptions.prototype, "validation", void 0);
